import { Injectable } from '@angular/core';
import { SupabaseService } from '../providers/supabase.service';
import { AbTestEvent, AbTestVariation } from '../models/db-types';
import { MotesCookieService } from '../cookie/cookie.service';

@Injectable({ providedIn: 'root' })
export class AbTestService {
    constructor(private supabaseService: SupabaseService, private cookieService: MotesCookieService) {
    }

    public async getAbTestVariation(abTestKey: 'CartOptimization' | 'AppTourPage') : Promise<AbTestVariation> {
        const visitorKey = await this.cookieService.getVisitorKey();
        const cli = this.supabaseService.getAnonSupabaseClient();
        const { data:abTestVariation, error } = await cli.rpc('ab_test_assign_variation', { test_key: abTestKey, visitor_key: visitorKey });
        if(error) {
            console.warn("Could not get A/B test variation", error);
            return null;
        }
        return abTestVariation;
    }

    public async createAbTestEvent(abTestVariationId: string, eventName: string) : Promise<AbTestEvent | null>{
        const visitorKey = await this.cookieService.getVisitorKey();
        if(!visitorKey || !abTestVariationId) {
            console.warn("Could nto create ab test event - no visitorKey or variation id", visitorKey, abTestVariationId);
            return null;
        }

        // Register supabase A/B test conversion event
        const cli = this.supabaseService.getAnonSupabaseClient();

        const { data, error } = await cli.from('ab_test_event').insert( {
            abTestVariationId: abTestVariationId,
            eventName: eventName,
            visitorKey: visitorKey
        });

        if(error) {
            console.warn("Could not create ab test event", error);
            return null
        }

        return data;
    }
}
